import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { useSale, countdownSale } from '../utils/sale';

function diffParts(endsAt) {
  const ms = new Date(endsAt) - new Date();
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
}

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="text-lg sm:text-xl font-bold tabular-nums text-cyan-700 leading-none">
      {String(value).padStart(2, '0')}
    </span>
    <span className="text-[9px] sm:text-[10px] font-medium uppercase tracking-wide text-cyan-600/70 mt-0.5">
      {label}
    </span>
  </div>
);

export const SaleCountdown = ({ className = '', item }) => {
  const saleData = useSale();
  const sale = countdownSale(saleData, item);
  const [parts, setParts] = useState(() => (sale ? diffParts(sale.endsAt) : null));

  useEffect(() => {
    if (!sale) {
      setParts(null);
      return;
    }
    const tick = () => setParts(diffParts(sale.endsAt));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [sale]);

  if (!sale || !parts) return null;

  return (
    <div
      data-testid="sale-countdown"
      className={`inline-flex items-center gap-3 rounded-xl border border-cyan-200 bg-cyan-50 px-4 py-2.5 ${className}`}
    >
      <Clock size={18} className="text-cyan-600 shrink-0" />
      <span className="text-sm font-semibold text-cyan-700">
        {sale.label || `${sale.percent}% off`} ends in
      </span>
      <div className="flex items-center gap-1.5">
        <Unit value={parts.d} label="days" />
        <span className="text-cyan-400 font-bold pb-3">:</span>
        <Unit value={parts.h} label="hrs" />
        <span className="text-cyan-400 font-bold pb-3">:</span>
        <Unit value={parts.m} label="min" />
        <span className="text-cyan-400 font-bold pb-3">:</span>
        <Unit value={parts.s} label="sec" />
      </div>
    </div>
  );
};

export default SaleCountdown;
